import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import Table from "../../../Utils/Table/Table";
import { GetBonus, getbrokerageData, getbrokerageDataINR, GetBonusInr } from "../../../Services/Admin/Addmin";
import { getProfitMarginApi } from "../../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { HandCoins } from "lucide-react";
import { useLocation } from "react-router-dom";
const BonusAndBrokerage = () => {
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  const [data, setData] = useState([]);
  const [bonusData, setBonusData] = useState([]);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [completed, setCompleted] = useState(0);
  const [totalBrokerage, setTotalBrokerage] = useState(0);

  const state = useLocation()
  const [activeMarket, setActiveMarket] = useState(state?.state?.item === "rupee" ? "INR" : "USD");

  const columns = [
    { Header: "UserName", accessor: "UserName" },
    { Header: "Symbol", accessor: "symbol" },
    {
      Header: "Amount",
      accessor: "Amount",
      Cell: ({ cell }) => cell.value?.toFixed(3) || "-",
    },
    { Header: "Brokerage", accessor: "brokerage" },
    {
      Header: "Created At",
      accessor: "createdAt",
      Cell: ({ cell }) => fDateTimesec(cell.value),
    },
  ];

  const columnsForBonus = [
    { Header: "UserName", accessor: "username" },
    {
      Header: "Bonus",
      accessor: "Bonus",
      Cell: ({ cell }) => cell.value?.toFixed(3) || "-",
    },
    {
      Header: "Type",
      accessor: "Type",
      Cell: ({ cell }) => {
        const typeMap = {
          Fund_Add: "Deposit Bonus",
          Fixed_PerClient: "Per Client Bonus",
          Every_Transaction: "Per Transaction Bonus",
        };
        return typeMap[cell.value] || cell.value;
      },
    },
    {
      Header: "Created At",
      accessor: "createdAt",
      Cell: ({ cell }) => fDateTimesec(cell.value),
    },
  ];

  useEffect(() => {
    fetchAllData();
  }, [search, activeMarket]);

  useEffect(() => {
    if (user_id) fetchMarginData();
  }, [user_id]);

  const fetchAllData = async () => {
    try {
      // const [brokerageRes, bonusRes] = await Promise.all([
      //   getbrokerageData({ admin_id: user_id }),
      //   GetBonus({ admin_id: user_id }),
      // ]);


      const brokerageApi =
        activeMarket === "INR"
          ? getbrokerageDataINR
          : getbrokerageData;

      const bonusApi =
        activeMarket === "INR"
          ? GetBonusInr
          : GetBonus;
  
      const [brokerageRes, bonusRes] = await Promise.all([
        brokerageApi({ admin_id: user_id }),
        bonusApi({ admin_id: user_id }),
      ]);

      setCompleted(bonusRes?.CompletedBrokrageandBonus || 0);

      // Brokerage data structure
      const structuredData =
        brokerageRes.data?.map((item) => ({
          UserName: item.UserName,
          ...item.balance_data,
        })) || [];

      const filteredBrokerageData = structuredData
        .map((item) => ({
          UserName: item.UserName,
          symbol: item.symbol,
          Amount: item.Amount,
          brokerage: item.brokerage,
          createdAt: item.createdAt,
        }))
        .filter(
          (item) =>
            !search ||
            item.symbol?.toLowerCase().includes(search.toLowerCase()) ||
            item.UserName?.toLowerCase().includes(search.toLowerCase())
        );

      setData(filteredBrokerageData);

      // Bonus data filtering
      const bonusList = bonusRes.data || [];
      const filteredBonusData = bonusList.filter(
        (item) =>
          !search ||
          item.username?.toLowerCase().includes(search.toLowerCase()) ||
          item.Type?.toLowerCase().includes(search.toLowerCase())
      );

      setBonusData(filteredBonusData);

      // Total brokerage calculation
      const totalBrokerageVal =
        structuredData.reduce(
          (acc, item) => acc + Number(item.brokerage || 0),
          0
        ) + bonusList.reduce((acc, item) => acc + Number(item.Bonus || 0), 0);

      setTotalBrokerage(totalBrokerageVal);
    } catch (err) {
      Swal.fire("Error", "Failed to fetch data. Please try again.", "error");
    }
  };

  const fetchMarginData = async () => {
    try {
      await getProfitMarginApi({ admin_id: user_id });
    } catch (error) { }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="card shadow-sm">
        <div className=" card-header border-0 flex-wrap">
          <h2 className="text-sm flex items-center gap-2">
            <HandCoins size={24} />  Brokerage and Bonus
          </h2>

          <div className="wallet-tabs">
            <div className="btn-group" role="group">

              {TokenData?.market.includes(0) && <button
                type="button"
                className={`btn ${activeMarket === "USD" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setActiveMarket("USD")}
              >
                <i className="fas fa-dollar-sign me-2"></i>
                USD Wallet
              </button>}

              {TokenData?.market.includes(1) && <button
                type="button"
                className={`btn ${activeMarket === "INR" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setActiveMarket("INR")}
              >
                <i className="fas fa-rupee-sign me-2"></i>
                INR Wallet
              </button>}

            </div>
          </div>

        </div>
        <div className="card-body custom-bg">


          {/* Search Input */}
          <div className="mb-3 mt-2">
            <label className="form-label fw-semibold text-dark">🔍 Search:</label>
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Search by Symbol, Username, or Type..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ maxWidth: "300px" }}
            />
          </div>

          {/* Summary Cards */}
          <div className="row mb-3">
            {[
              { label: "Total Brokerage", value: totalBrokerage },
              { label: "Remaining", value: totalBrokerage - completed },
              { label: "Completed", value: completed },
            ].map((item, idx) => (
              <div key={idx} className="col-md-4">
                <div className="card border-0 shadow-lg">
                  <div className="card-body py-3">
                    <h6 className="mb-1 fw-bold">{item.label}</h6>
                    <div className="form-control-plaintext fw-semibold">
                      {item.value.toFixed(3)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Tabs Section */}
          <Tabs defaultActiveKey="Brokerage" className="mb-3 custom-tabs" justify>
            <Tab eventKey="Brokerage" title="Brokerage">
              <Table columns={columns} data={data} rowsPerPage={rowsPerPage} isPage={true} />
            </Tab>

            <Tab eventKey="Bonus" title="Bonus">
              <Table
                columns={columnsForBonus}
                data={bonusData}
                rowsPerPage={rowsPerPage}
                isPage={true}
              />
              
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default BonusAndBrokerage;
